import { jsx } from 'react/jsx-runtime';
import { useLabel } from '@websolutespa/bom-mixer-hooks';
import { Text } from '../../components/Text/text.js';

const FormRecapError = () => {
  const label = useLabel();
  return jsx("div", {
    className: "llm__row",
    children: jsx("div", {
      className: "llm__col --sm-10 --md-8 --lg-6",
      children: jsx(Text, {
        body: label('llm.formRecapError')
      })
    })
  });
};

export { FormRecapError };
//# sourceMappingURL=FormRecapError.js.map
